import { toCamelCase } from "../../../Payroll/helper-payroll/HelperFunction";
import { _getCasesType } from "../payrollCases/PayrollCasesPage";
import { caseFieldHandlers } from "./caseFieldHandler";
export const sumArray = (arr, shouldReturnNum = false) => {
  if (!shouldReturnNum) {
    if (!Array.isArray(arr)) return 0;
  }else{
    return arr;
  }
  return arr.reduce((total, num) => total + num, 0);
};

export const _labelKeyPairs = (items = []) => {
  return items.map((item) => ({
    key: item,
    label: item,
  }));
};

export const _parseKeyValueArray = (items = []) => {
  const result = {};
  for (const item of items) {
    const [key, value] = item.split(":");
    if (key && value !== undefined) {
      result[key] = value.trim();
    }
  }
  return result;
};

export const _camelToLabel = (str) =>
  str.replace(/([A-Z])/g, " $1").replace(/^./, (s) => s.toUpperCase());

export const _getCaseHandler = (caseType, obj) => {
  const handler = caseFieldHandlers[caseType];
  return handler ? handler(obj) : {};
};

export const _parseKeyValueArrayToObject = (target, array) => {
  if (!Array.isArray(array)) return;

  array.forEach((entry) => {
    const [key, value] = entry.split(":").map((x) => x.trim());

    if (key && value !== undefined) {
      if (
        value.includes(",") &&
        value.split(",").every((v) => !isNaN(v.trim()))
      ) {
        target[key] = value.split(",").map((v) => parseFloat(v.trim()));
      } else {
        target[key] = isNaN(value) ? value : parseFloat(value);
      }
    }
  });
};

export const _getNumericSum = (val) => {
  if (Array.isArray(val)) {
    return val.reduce((acc, n) => {
      if (typeof n === "number") return acc + n;

      if (typeof n === "string") {
        const match = n.match(/[-+]?[0-9]*\.?[0-9]+$/);
        const num = match ? parseFloat(match[0]) : 0;
        return acc + (isNaN(num) ? 0 : num);
      }

      return acc;
    }, 0);
  }

  if (typeof val === "string") {
    const match = val.match(/[-+]?[0-9]*\.?[0-9]+$/);
    return match ? parseFloat(match[0]) : 0;
  }

  return typeof val === "number" ? val : 0;
};

export const _getHeaders = ({ label, contributionKeys, deductionKeys }) => {
  const headerRow_1 = [];
  const headerRow_2 = [];
  const merges = [];

  let colIndex = 0;
  while (colIndex < label.length) {
    const item = label[colIndex];
    const key = item.key;
    const labelText = item.label;

    let group = "";
    if (contributionKeys.find((k) => k.key === key)) {
      group = "MANDATORY DEDUCTIONS";
    } else if (deductionKeys.find((k) => k.key === key)) {
      group = "LOANS & OTHER DEDUCTIONS";
    }

    if (group) {
      const start = colIndex;
      let end = colIndex;
      for (let j = colIndex + 1; j < label.length; j++) {
        const nextKey = label[j].key;
        const nextGroup = contributionKeys.find((k) => k.key === nextKey)
          ? "MANDATORY DEDUCTIONS"
          : deductionKeys.find((k) => k.key === nextKey)
          ? "LOANS & OTHER DEDUCTIONS"
          : "";

        if (nextGroup !== group) break;
        end++;
      }

      for (let i = start; i <= end; i++) {
        headerRow_1.push(i === start ? group : "");
        headerRow_2.push(label[i].label);
      }

      if (end > start) {
        merges.push({ s: { r: 0, c: start }, e: { r: 0, c: end } });
      }

      colIndex = end + 1;
    } else {
      headerRow_1.push("");
      headerRow_2.push(labelText);
      colIndex++;
    }
  }

  return { headerRow_1, headerRow_2, merges };
};

export const _getLabels = (schema, fieldsToExclude) => {
  return Object.keys(schema.fields)
    .filter((fieldName) => {
      const config = schema.fields[fieldName];
      return (
        config &&
        config.read !== false &&
        fieldsToExclude.includes(fieldName) &&
        fieldName !== "contributions" &&
        fieldName !== "deductions"
      );
    })
    .map((fieldName) => ({
      key: fieldName,
      label: schema.fields[fieldName].label || _camelToLabel(fieldName),
    }));
};

/** Flattened employee columns used by the payroll table and Excel export. */
export const EMPLOYEE_TABLE_FIELD_KEYS = [
  "employeeNumber",
  "accountNumber",
  "lastName",
  "firstName",
  "middleName",
];

export const _getEmployeeTableFields = (isJoItem = false) => ({
  employeeNumber: {
    type: "String",
    label: "EMPLOYEE NUMBER",
    align: "start",
  },
  accountNumber: {
    type: "String",
    label: isJoItem ? "ACCOUNT NUMBER" : "ACCT NO.",
    align: "start",
  },
  lastName: { type: "String", label: "LAST NAME", align: "start" },
  firstName: { type: "String", label: "FIRST NAME", align: "start" },
  middleName: { type: "String", label: "MIDDLE NAME", align: "start" },
});

export const _expandEmployeeNameColumns = (label = [], isJoItem = false) => {
  const employeeIndex = label.findIndex(({ key }) => key === "employee");
  if (employeeIndex === -1) return label;

  const employeeFields = _getEmployeeTableFields(isJoItem);
  const employeeColumns = EMPLOYEE_TABLE_FIELD_KEYS.map((key) => ({
    key,
    label: employeeFields[key].label,
  }));

  return [
    ...label.slice(0, employeeIndex),
    ...employeeColumns,
    ...label.slice(employeeIndex + 1),
  ];
};

export const _expandEmployeeInFieldOrder = (fields = []) => {
  const result = [];
  for (const field of fields) {
    if (field === "employee") {
      result.push(...EMPLOYEE_TABLE_FIELD_KEYS);
    } else {
      result.push(field);
    }
  }
  return result;
};

export const _getEarnedPeriodLabel = (month) =>
  month ? `EARNED FOR THE PERIOD (${month})` : "EARNED FOR THE PERIOD";

/** Override earned-period export headers while keeping field keys unchanged. */
export const _withEarnedPeriodExportLabels = (labels = [], object = {}) =>
  labels.map((item) => {
    if (item.key === "earnedForThePeriodFrom") {
      return {
        ...item,
        label: _getEarnedPeriodLabel(object?.startDate),
      };
    }
    if (item.key === "earnedForThePeriodTo") {
      return {
        ...item,
        label: _getEarnedPeriodLabel(object?.endDate),
      };
    }
    return item;
  });

const _flattenEmployeeFields = (employee) => ({
  employeeNumber: employee?.agency || "",
  accountNumber: employee?.accountNumber || "",
  lastName: employee?.surname || "",
  firstName: employee?.Firstname || "",
  middleName: employee?.Middlename || "",
});

function shouldApplyContributions(cases) {
  return (
    !cases.fourthCase &&
    !cases.sixthCase &&
    !cases.eightCase &&
    !cases.ninthCase &&
    !cases.tenthCase &&
    !cases.eleventhCase &&
    !cases.thirteenthCase &&
    !cases.twelveCase
  );
}

// function shouldApplyDeductions(cases) {
//   // Always apply except for eighthCase
//   return !cases.eighthCase;
// }

export const _mergeDynamicKeys = ({
  label,
  object,
  contributionKeys,
  deductionKeys,
  incentiveKeys,
}) => {
  const cases = _getCasesType(object);

  // console.log("CASESSSS", cases);
  const netAmountIndex = label.findIndex(({ key }) => key === "netAmount");
  const insertIndex = netAmountIndex >= 0 ? netAmountIndex : label.length;

  let offset = 0;

  if (shouldApplyContributions(cases)) {
    label.splice(insertIndex + offset, 0, ...contributionKeys);
    offset += contributionKeys.length;
  }

  // if (shouldApplyDeductions(cases)) {
  label.splice(insertIndex + offset, 0, ...deductionKeys);
  // }

  if (cases.thirteenthCase) {
    label.splice(insertIndex + offset, 0, ...incentiveKeys);
  }

  return label;
};

export const _processExportData = ({
  objects,
  label,
  object,
  contributionKeys,
  deductionKeys,
  incentiveKeys,
}) => {
  const cases = _getCasesType(object);
  const conditionalKeys = !cases.thirteenthCase ? deductionKeys : incentiveKeys;

  return objects.map((obj, index) => {
    const rowObj = { ...obj };

    // Flatten employee pointer into separate export columns
    if (rowObj.employee && typeof rowObj.employee === "object") {
      Object.assign(rowObj, _flattenEmployeeFields(rowObj.employee));
    }

    // Flatten contributions
    if (Array.isArray(rowObj?.contributions)) {
      const contributionsMap = _parseKeyValueArray(rowObj.contributions);
      contributionKeys.forEach(({ key }) => {
        const convertedKey = toCamelCase(key);
        rowObj[key] = contributionsMap[convertedKey] || "";
      });
    }

    // Flatten deductions
    if (Array.isArray(rowObj?.deductions)) {
      const deductionsMap = _parseKeyValueArray(rowObj.deductions);

      conditionalKeys.forEach(({ key }) => {
        const convertedKey = toCamelCase(key);
        rowObj[key] = deductionsMap[convertedKey] || "";
      });
    }

    const processedRow = {};
    label.forEach(({ key, label: headerLabel }) => {
      const val = rowObj[key];
      processedRow[headerLabel] = val == null ? "" : String(val);
    });

    return processedRow;
  });
};

export const _appendWithKeys = (objects, object) => {
  const contributionKeys = object.contributions || [];
  const deductionKeys = object.deductions || [];
  const incentiveKeys = object.incentives || [];

  const cases = _getCasesType(object);
  const conditionalKeys = !cases.thirteenthCase ? deductionKeys : incentiveKeys;

  return objects.map((item) => {
    const newItem = { ...item };

    let contributionsMap = {};
    let deductionsMap = {};

    if (Array.isArray(item.contributions)) {
      contributionsMap = _parseKeyValueArray(item.contributions);
    }

    if (Array.isArray(item.deductions)) {
      deductionsMap = _parseKeyValueArray(item.deductions);
    }

    if (item.employee && typeof item.employee === "object") {
      Object.assign(newItem, _flattenEmployeeFields(item.employee));
      delete newItem.employee;
    }

    delete newItem.contributions;
    delete newItem.deductions;

    if (shouldApplyContributions(cases)) {
      contributionKeys.forEach((label) => {
        const camelKey = toCamelCase(label);
        newItem[label] = contributionsMap[camelKey] ?? 0;
      });
    }

    conditionalKeys.forEach((label) => {
      const camelKey = toCamelCase(label);
      newItem[label] = deductionsMap[camelKey] ?? 0;
    });

    return newItem;
  });
};

export const _appendWithFields = (filteredFieldSchema, object, isJoItem = false) => {
  const contributionFields = {};
  const deductionFields = {};

  const cases = _getCasesType(object);

  const conditionalDeductions =
    (!cases.thirteenthCase ? object?.deductions : object?.incentives) ?? [];

  (object?.contributions ?? []).forEach((item) => {
    contributionFields[item] = {
      type: "String",
      label: item,
    };
  });

  conditionalDeductions.forEach((item) => {
    deductionFields[item] = {
      type: "String",
      label: item,
    };
  });

  const finalSchema = {};

  for (const key of Object.keys(filteredFieldSchema)) {
    if (key === "netAmount") {
      if (shouldApplyContributions(cases)) {
        Object.assign(finalSchema, contributionFields);
      }
      Object.assign(finalSchema, deductionFields);
    }

    if (key === "employee") {
      Object.assign(finalSchema, _getEmployeeTableFields(isJoItem));
      continue;
    }

    finalSchema[key] = filteredFieldSchema[key];
  }

  return finalSchema;
};

export const _getExtrasAndDeductions = (otherDeduction) => {
  const { DEDUCTION, ADDITIONAL } = otherDeduction.reduce(
    (acc, item) => {
      const isDeduction = item?.deductionTypes === "Other Deduction";
      const isAdditional = item?.deductionTypes === "Other Additional";

      if (!item?.accTitleRelation || (!isDeduction && !isAdditional))
        return acc;

      for (const rel of item?.accTitleRelation) {
        const name = rel?.accountsTitle?.name;
        if (!name) continue;

        if (isDeduction) acc.DEDUCTION.push(name);
        else if (isAdditional) acc.ADDITIONAL.push(name);
      }

      return acc;
    },
    { DEDUCTION: [], ADDITIONAL: [] }
  );

  return {
    DEDUCTION,
    ADDITIONAL,
  };
};
